export const breakpoints = {
  md: "@media screen and (min-width: 1150px)",
};
